export enum TeamRelationship {
  MEMBER  = 'MEMBER',
  MANAGER = 'MANAGER',
}

export interface ITeamAssociation {
  uuid: string;
  name: string;
  relationship: TeamRelationship;
}

export interface IUserAssignmentSummary {
  moduleAssignmentUuid: string;
  name: string;
  status: string;
  excludeReporting: boolean;
  teamAssociations: ITeamAssociation[];
}
